<template>
  <f7-page @page:beforein="beforeIn">
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }} ({{ resultProject.name }})
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('IrrigationPage_navbar_title') }}</span>
      </template>
    </navbar>
    <f7-block-title class="block-title-result">
      <span :class="`color-title-${selection}`">
        {{
          `${
            $t(keyName === '/infoIrrigation/'
              ? 'result.title_recomendation_irrigation'
              : 'result.title_detail_irrigation_2'
            ).toUpperCase()}`
        }}
      </span>
    </f7-block-title>
    <div
      v-if="selection === 'GreenHouse'"
      class="content-devx transparent headers-initial"
      style="padding: 1rem 0 !important;"
    >
      <div v-if="keyName === '/infoIrrigation/' && loaded">
        <InfoIrrigation
          :data="data"
        />
        <div
          class="select-button"
          style="padding-top: 1rem;"
        >
          <DxButton
            name="btnSignIn"
            class="selected-button"
            style="color:#FFFFFF;"
            @click="openSensorIrrigation"
          >
            {{ 'Manejo correctivo del riego con sensores' }}
          </DxButton>
        </div>
      </div>
      <div v-if="keyName === '/detailInformation/' && loaded">
        <DetailInfoIrrigation
          :data="originalData"
        />
      </div>
      <div
        v-if="keyName === '/detailInformation/' && loaded"
        style="margin-top: 2rem;"
      >
        <ChartIrrigation
          :data="originalData"
          :vol-irr="volIrr"
          :vol-acum="volAcum"
          :eto="etoData"
          :kc="kcData"
          :etc="etcData"
          :key-name="keyName"
        />
      </div>
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-link
        popover-open=".popover-menu"
        data-popover=".links-popover"
        class="dx-btn-success dx-btn-see-more sm-popover"
      >
        {{ $t('seeMore') }}
      </f7-link>
      <f7-popover class="popover-menu links-popover">
        <f7-list>
          <f7-list-item
            v-if="keyName === '/infoIrrigation/'"
            link="/detailInformation/"
            popover-close
            :title="$t('result.title_detail_irrigation')"
          />
          <f7-list-item
            v-else
            link="/infoIrrigation/"
            popover-close
            :title="$t('result.title_recomendation_irrigation')"
          />
        </f7-list>
      </f7-popover>
      <f7-button
        class="dx-btn-cancel color-GreenHouse"
        raised
        type="default"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToHomePage"
      >
        {{ $t('button_back') }}
      </f7-button>
    </f7-block-footer>
    <DxPopUpSensorIrrigation />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DxButton from 'devextreme-vue/button';
import navbar from '../../../../../components/navbar/NavBar.vue';
import InfoIrrigation from '../../../../../components/irrigationResult/infoIrrigation/index.vue';
import ChartIrrigation from '../../../../../components/irrigationResult/chartIrrigation/index.vue';
import DetailInfoIrrigation from '../../../../../components/irrigationResult/detailInformation/index.vue';
import { NUMBER_OF_DECIMALS, DEVICE_PLATFORM } from '../../../../../js/constants';
import DxPopUpSensorIrrigation from '../../../../../components/irrigationResult/popUpSensorIrrigation/index.vue';

export default {
  name: 'InfoIrrigationPageGH',
  components: {
    navbar,
    InfoIrrigation,
    ChartIrrigation,
    DetailInfoIrrigation,
    DxPopUpSensorIrrigation,
    DxButton,
  },
  data() {
    return {
      data: [],
      volIrr: [],
      volAcum: [],
      etoData: [],
      kcData: [],
      detailInformation: [],
      etcData: [],
      keyName: '',
      loaded: false,
      NUMBER_OF_DECIMALS,
      originalData: [],
      DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Result', [
      'resultProject',
    ]),
    selectionClass() {
      return this.selection === 'GreenHouse' ? 'dx-btn-success color-orange' : 'dx-btn-success open-air';
    },
  },
  methods: {
    beforeIn() {
      this.keyName = this.$f7.views.main.router.currentRoute.path;
      const accumIrrigationVolume = [];
      this.resultProject.result.irrigation_volume
        .reduce((prev, curr, i) => accumIrrigationVolume[i] = prev + curr, 0);
      const tempData = this.resultProject.result.irrigation_etc_day
        .map((irrigationEtcDay, index) => ({
          ddt: index,
          date: this.resultProject.result.dates[index],
          irrigation_etc_day: irrigationEtcDay,
          irrigation_time: this.resultProject.result.irrigation_time[index],
          irrigation_volume: this.resultProject.result.irrigation_volume[index],
          accumulated_irrigation_volume: accumIrrigationVolume[index],
          irrigation_eto: this.resultProject.result.irrigation_eto
            ? this.resultProject.result.irrigation_eto[index] : null,
          irrigation_kc: this.resultProject.result.irrigation_kc[index],
          irrigation_etc_day_fixed: Number(irrigationEtcDay.toFixed(this.NUMBER_OF_DECIMALS)),
          irrigation_time_fixed: Number(this.resultProject.result.irrigation_time[index]
            .toFixed(0)),
          irrigation_volume_fixed: Number(this.resultProject.result.irrigation_volume[index]
            .toFixed(this.NUMBER_OF_DECIMALS)),
          accumulated_irrigation_volume_fixed: Number(accumIrrigationVolume[index]
            .toFixed(this.NUMBER_OF_DECIMALS)),
          irrigation_eto_fixed: this.resultProject.result.irrigation_eto
            ? Number(this.resultProject.result.irrigation_eto[index].toFixed(this.NUMBER_OF_DECIMALS))
            : null,
          irrigation_kc_fixed: Number(this.resultProject.result.irrigation_kc[index]
            .toFixed(this.NUMBER_OF_DECIMALS)),
          crop_cycle_week: Math.trunc(index / 7),
          weekday: this.getWeekDay(this.resultProject.result.dates[index]),
        }));

      this.originalData = this.resultProject.result.irrigation_etc_day
        .map((irrigationEtcDay, index) => ({
          ddt: index,
          date: this.resultProject.result.dates[index],
          irrigation_etc_day: irrigationEtcDay,
          irrigation_time: Number(this.resultProject.result.irrigation_time[index].toFixed(0)),
          irrigation_volume: this.resultProject.result.irrigation_volume[index],
          accumulated_irrigation_volume: accumIrrigationVolume[index],
          irrigation_eto: this.resultProject.result.irrigation_eto
            ? this.resultProject.result.irrigation_eto[index]
            : null,
          irrigation_kc: this.resultProject.result.irrigation_kc[index],
          irrigation_etc_day_fixed: Number(irrigationEtcDay.toFixed(this.NUMBER_OF_DECIMALS)),
          irrigation_time_fixed: Number(this.resultProject.result.irrigation_time[index]
            .toFixed(0)),
          irrigation_volume_fixed: Number(this.resultProject.result.irrigation_volume[index]
            .toFixed(this.NUMBER_OF_DECIMALS)),
          accumulated_irrigation_volume_fixed: Number(accumIrrigationVolume[index]
            .toFixed(this.NUMBER_OF_DECIMALS)),
          irrigation_eto_fixed: this.resultProject.result.irrigation_eto
            ? Number(this.resultProject.result.irrigation_eto[index].toFixed(this.NUMBER_OF_DECIMALS))
            : null,
          irrigation_kc_fixed: Number(this.resultProject.result.irrigation_kc[index]
            .toFixed(this.NUMBER_OF_DECIMALS)),
          crop_cycle_week: Math.trunc(index / 7),
          weekday: this.getWeekDay(this.resultProject.result.dates[index]),
        }));
      this.data = [];
      if (tempData.length) {
        tempData.splice(0, 1);
        switch (tempData[0].weekday) {
          case 'M':
            tempData.unshift({
              weekday: 'L',
              crop_cycle_week: 0,
              ddt: 0,
              irrigation_time: 0,
              irrigation_time_fixed: 0,
              irrigation_volume: 0,
              irrigation_volume_fixed: 0,
            });
            break;
          case 'Mierc':
            tempData.unshift(
              {
                weekday: 'L',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'M',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
            );
            break;
          case 'J':
            tempData.unshift(
              {
                weekday: 'L',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'M',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'Mierc',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
            );
            break;
          case 'V':
            tempData.unshift(
              {
                weekday: 'L',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'M',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'Mierc',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'J',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
            );
            break;
          case 'S':
            tempData.unshift(
              {
                weekday: 'L',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'M',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'Mierc',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'J',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              }, {
                weekday: 'V',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
            );
            break;
          case 'D':
            tempData.unshift(
              {
                weekday: 'L',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'M',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'Mierc',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'J',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'V',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'S',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
            );
            break;
          case 'L':
            tempData.unshift(
              {
                weekday: 'D',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'L',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'M',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'Mierc',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'J',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'V',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
              {
                weekday: 'S',
                crop_cycle_week: 0,
                ddt: 0,
                irrigation_time: 0,
                irrigation_time_fixed: 0,
                irrigation_volume: 0,
                irrigation_volume_fixed: 0,
              },
            );
            break;
          default:
            break;
        }
        tempData.forEach((item, index) => {
          item.crop_cycle_week = Math.trunc(index / 7);
        });
        let cropCycleWeek = null;
        let initPeriodDate = '';
        let nDays = 0;
        tempData.forEach((item, index) => {
          if (
            item.crop_cycle_week === cropCycleWeek
              || item.crop_cycle_week === 1
              || tempData.length - index < 7
          ) {
            this.data[this.data.length - 1].irrigation_time = this.data[this.data.length - 1]
              .irrigation_time + item.irrigation_time;
            if (this.data[this.data.length - 1].irrigation_time) {
              this.data[this.data.length - 1].irrigation_time_fixed = Number(this.data[this.data.length - 1]
                .irrigation_time.toFixed(0));
            }

            this.data[this.data.length - 1].irrigation_volume = this.data[this.data.length - 1]
              .irrigation_volume + item.irrigation_volume;
            if (this.data[this.data.length - 1].irrigation_volume) {
              this.data[this.data.length - 1].irrigation_volume_fixed = Number(this.data[this.data.length - 1]
                .irrigation_volume.toFixed(this.NUMBER_OF_DECIMALS));
            }
            if (!initPeriodDate && item.date) {
              initPeriodDate = `${item.date} al `;
            }
            this.data[this.data.length - 1].date = initPeriodDate.concat(item.date);
            if (item.date) {
              nDays += 1;
            }
            this.data[this.data.length - 1].n_days = nDays;
            if (item.crop_cycle_week === 1) {
              this.data[this.data.length - 1].crop_cycle_week = 1;
            }
          } else {
            this.data.push(item);
            cropCycleWeek = item.crop_cycle_week;
            if (item.date) {
              initPeriodDate = `${item.date} al `;
              nDays = 1;
            }
            this.data[this.data.length - 1].n_days = nDays;
          }
        });
        // this.data = tempData;
      }
      if (this.originalData.length) {
        this.originalData.splice(0, 1);
      }
      this.loaded = true;
      this.$f7.preloader.hide();
    },
    goToHomePage() {
      this.$f7.views.main.router.navigate('/tabs-result-greenhouse/', { reloadCurrent: true });
    },
    getWeekDay(strDate) {
      const [day, month, year] = strDate.split('/');
      const date = new Date(+year, month - 1, +day);
      const weekday = date.getDay();
      switch (weekday) {
        case 0:
          return 'D';
        case 1:
          return 'L';
        case 2:
          return 'M';
        case 3:
          return 'Mierc';
        case 4:
          return 'J';
        case 5:
          return 'V';
        case 6:
          return 'S';
        default:
          return weekday;
      }
    },
    openSensorIrrigation() {
      this.setEnabledPopUpSensor(true);
    },
    ...mapActions('Result', [
      'setEnabledPopUpSensor',
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../../css/mixins";
.select-button {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding-top: 150px;
  align-items: center;
  font-size: 25px !important;
}
.content-note {
  margin: 2rem;
  max-width: 1080px;
}
.note {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  text-align: center;
  line-height: normal;
  color: steelblue;
  font-size: small;
  @include md {
    font-size: large;
    line-height: 28px;
  }
}

.selected-button {
  display: flex;
  background: #FF7F26;
  width: 250px;
  border-radius: 4px;
  height: auto;
  box-shadow: none;
  font-size: 1rem !important;
  line-height: 20px !important;
}
</style>
